import { cliente } from '@/lib/cliente';
import { useQuery } from '@tanstack/react-query';

/**
 * Carga el bundle de detalle de una obra para el drawer.
 * `worksNo` puede ser null cuando el drawer está cerrado — en ese caso
 * el hook queda enabled=false y no hace fetch.
 */
export function useObraDetalle(worksNo: string | null) {
  return useQuery({
    queryKey: ['obra-detalle', worksNo],
    queryFn: () => cliente.obra.detalle(worksNo!),
    enabled: !!worksNo,
    staleTime: 60_000, // cache 1 min
  });
}
